import React, { Component } from "react";
import { fire, auth } from "../../../firebase/index";
import LocalizedStrings from "react-localization";

let localizationStrings = new LocalizedStrings({
  en: {
    reply1:
      "Despite it being able to repeatedly notify you when battery run low via your smartphone or blinking LED of the smartlock, when ultimately the batteries run out, you still have the following options:",
    reply2:
      "1) Use a standard external USB mobile power source (e.g. your Laptop PC or USB power bank) to power all models of eGeeTouch® smart lock via the USB terminal provided, and then proceeds with unlocking as usual.",
    reply3:
      "2) And for smart luggage lock, use the backup mechanical (individual) key provided as additional option to open the lock through the TSA master key hole.",
    back: "Back",
  },
  ja: {
    reply1:
      "バッテリーが少なくなるとスマートフォンやスマートロックの LED の点滅で繰り返し通知できますが、最終的にバッテリーが切れた場合は、次のオプションがあります。",
    reply2:
      "1) 標準の外部 USB モバイル電源 (ラップトップ PC や USB パワーバンクなど) を使用して、付属の USB 端子経由で eGeeTouch® スマート ロックのすべてのモデルに電力を供給し、通常どおりロック解除を続行します。",
    reply3:
      "2) スマートラゲッジロックの場合は、追加オプションとして提供されるバックアップメカニカル（個別）キーを使用して、TSAマスターキーホールを通してロックを開きます。",
    back: "戻る",
  },
  es: {
    reply1:
      "A pesar de poder notificarte repetidamente cuando la batería se está agotando a través de tu teléfono inteligente o del LED parpadeante de la candado inteligente, cuando finalmente se agotan las baterías, todavía tienes las siguientes opciones:",
    reply2:
      "1) Utilice una fuente de alimentación móvil USB externa estándar (por ejemplo, su computadora portátil o un banco de energía USB) para alimentar todos los modelos de candado inteligente eGeeTouch® a través del terminal USB provisto y luego continúe con el desbloqueo como de costumbre.",
    reply3:
      "2) Y para el candado de equipaje inteligente, utilice la llave mecánica de respaldo (individual) proporcionada como opción adicional para abrir el candado a través del orificio de la llave maestra TSA.",
    back: "Atrás",
  },
});

class Q6_component extends Component {
  constructor(props) {
    super(props);

    this.state = {
      triggerValue: "0",
      clicked: false,
      language: "en",
    };
  }

  componentDidMount() {
    if (auth.currentUser !== null) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .on("value", this._langCb = (snapshot) => {
          localizationStrings.setLanguage(snapshot.val());
          this.setState({ language: snapshot.val() });
        });
    }
  }

  handleButtonClick2 = () => {
    if (!this.state.clicked) {
      this.setState({ triggerValue: "cancel", clicked: true }, () => {
        this.props.triggerNextStep({
          value: "cancel",
          trigger: "cancel",
        });
      });
    }
  };

  componentWillUnmount() {
    if (auth.currentUser !== null && this._langCb) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .off("value", this._langCb);
    }
  }

  render() {
    const buttonStyle = {
      marginTop: "10px",
      width: "215px",
      backgroundColor: "#FFC500",
      color: "black",
      borderRadius: "25px",
      textAlign: "center",
      padding: "10px 10px",
      cursor: "pointer",
      transition: "background-color 0.3s",
      border: "none",
    };

    const buttonHoverStyle = {
      color: "white",
      backgroundColor: "#EF6C00",
    };

    const { triggerValue, clicked } = this.state;

    return (
      <div>
        {localizationStrings.reply1}
        <br />
        <br />
        {localizationStrings.reply2}
        <br />
        <br />
        {localizationStrings.reply3}
        {/* <div>
          <img src="" />
          <img src="" />
        </div> */}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            margin: "12px 0",
          }}
        >
          <button
            style={{
              ...buttonStyle,
              ...(triggerValue === "cancel" && buttonHoverStyle),
            }}
            onMouseEnter={() => this.setState({ isButtonHovered: true })}
            onMouseLeave={() => this.setState({ isButtonHovered: false })}
            onClick={this.handleButtonClick2}
            disabled={clicked}
          >
            {localizationStrings.back}
          </button>
        </div>
      </div>
    );
  }
}

export default Q6_component;
